export type UserRole = 'BAN_HANG' | 'BEP';

export const getUserRole = (): UserRole | null => {
  const userTypeKey = localStorage.getItem('user_type_key');
  return userTypeKey === 'BAN_HANG' || userTypeKey === 'BEP' ? userTypeKey : null;
};

export const getHomePath = (): string => {
  const userRole = getUserRole();
  if (userRole === 'BAN_HANG') return '/banhang';
  if (userRole === 'BEP') return '/quan-ly-bep';
  return '/login';
};
